module.exports = __webpack_public_path__ + "static/media/star.a2812ff2.svg";